var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { nanoid } from 'nanoid';
import { BlocksElement } from '../BlocksElement';
import styles from './table.styles';
/**
 * @slot default - The table content
 * @slot caption - The table caption for accessibility which is visually hidden
 * @csspart base - The component's base wrapper.
 * @csspart caption-wrap - The component's caption wrapper.
 * @csspart part-caption - The component's caption slot.
 * @csspart part-default - The component's default slot.
 */
export class BlocksTable extends BlocksElement {
    static { this.styles = styles; }
    /**
     * Connected callback lifecycle
     * 1) Autogenerates aria-describedby ids to make this accessible if these properties aren't provided
     */
    connectedCallback() {
        super.connectedCallback();
        this.ariaDescribedBy = this.ariaDescribedBy || nanoid(); /* 1 */
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-table', {});
        return html `
      <div
        part="base"
        role="table"
        class=${componentClassName}
        aria-label=${ifDefined(this.arialabel)}
        aria-describedby=${ifDefined(this.slotNotEmpty('caption') || this.arialabel ? this.ariaDescribedBy : undefined)}
      >
        ${this.slotNotEmpty('caption') || this.arialabel
            ? html `
              <div part="caption-wrap" id=${ifDefined(this.ariaDescribedBy)} class="cat-c-table__caption cat-u-is-vishidden">
                ${this.slotNotEmpty('caption')
                ? html ` <slot part="part-caption" name="caption"></slot> `
                : this.arialabel
                    ? this.arialabel
                    : html `${nothing}`}
              </div>
            `
            : html `${nothing}`}
        ${html ` <slot part="part-default"></slot> `}
      </div>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksTable.prototype, "arialabel", void 0);
__decorate([
    property({ type: String })
], BlocksTable.prototype, "ariaDescribedBy", void 0);
if (customElements.get('cat-table') === undefined) {
    customElements.define('cat-table', BlocksTable);
}
